<template>
  <div class="desig-hander">
    <el-row :gutter="0" type="flex"  style="min-height: 100%;">
       <el-col :span="3">
         <span style="font-size: 1.5vh;font-weight: 600">AIM FOCUS |  </span><span>物联网控制系统设计工具</span>
       </el-col>
        <el-col :span="1" :offset="19">
          <i class="el-icon-user-solid" ></i>&nbsp;&nbsp;&nbsp;<span>{{name}}</span>
        </el-col>
        <el-col :span="1">
          <div style="margin-top: 1px">
            <el-dropdown trigger="click">
              <i class="el-icon-switch-button" ></i>
              <el-dropdown-menu slot="dropdown">
                <div @click="returnIndex">
                  <el-dropdown-item >返回首页</el-dropdown-item>
                </div>
                <!--<el-dropdown-item @click="logout">
                  <a style="font-size: 14px;color: #5b5b5b"
                     href="javaScript:void(0);"
                     @click="logout">
                    退出登录
                  </a>
                </el-dropdown-item>-->
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
    </el-row>
  </div>
</template>
<script>
import authorityService from '../../service/authorityService'
export default {
  name: '',
  components: {
    collapse: false
  },
  data () {
    return {
      name:'admin'
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    // 返回首页
    returnIndex(){
      this.$router.push({name: 'homePage'})
    },
    // 退出登录
    logout () {
      this.$store.state.loginStatus = false
      authorityService.logout().then(res => {
        localStorage.removeItem('Authorization')
        localStorage.removeItem('userInfo')
        this.$router.push({name: 'Login'})
        // location.reload()
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
  }
}
</script>
<style scoped>
  .desig-hander{
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    font-size: 15px;
  }
  .desig-hander span{
    font-size: 1vh;
    color: #FFFFFF;
  }
  .el-icon-user-solid{
    color: #FFFFFF;
  }
  .el-icon-switch-button{
    color: #FFFFFF;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/designtoolpages/TheHander.vue